"use client"
import Slider from "react-slick"
import "../slickslider.css"
import { getText } from "./strapi"
import { useContext } from "react"
import { Context } from "../store/store"
import { Link } from "react-router-dom"

function Info() {
	const { globalState } = useContext(Context)
	var settings = {
		dots: false,
		infinite: true,
		speed: 100,
		slidesToShow: 3,
		slidesToScroll: 1,
		swipeToSlide: true,
		initialSlide: 0,
		arrows: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					dots: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					autoplay: true,
					autoplaySpeed: 3000,
					slidesToShow: 1.04,
					dots: false,
					speed: 300,
					infinite: true,
					slidesToScroll: 1,
				},
			},
		],
	}
	return (
		<div>
			<div className="mx-auto  mb-12 max-w-[1400px] px-6 mt-20">
				<h2 className="">{getText(globalState.strapi.homepage.newProducts, "newProducts")}</h2>
			</div>
			<div className="w-full">
				<Slider {...settings}>
					<img src={"/images/neuKirsch.jpg"} className="w-full" />
					<img src={"/images/neuZitrone.jpg"} className="w-full" />
					<img src={"/images/neuMango.jpg"} className="w-full" />
				</Slider>
				<div className="rounded-border relative p-6">
					<p className="mt-12 mb-12 text-center copy text-[14px] lg:text-[19px] max-w-[540px]">
						{getText(globalState.strapi.homepage.activePeriod, "activePeriod")}{" "}
						<Link to={"/teilnahmebedingungen"} className="underline">
							Teilnahmebedingungen
						</Link>
						.
					</p>
				</div>
				<img src="/images/divider.png" alt="" className="-mb-[1px] w-full -scale-x-100 -scale-y-100" />
			</div>
		</div>
	)
}

export default Info
